import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Luciana', 'Martín', 'Camila', 'Santiago', 'Valentina', 'Nicolás', 'Florencia', 'Tomás'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentName(name);
      setCurrentCity(city);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup with random delay between 30-50 seconds
      timeoutId = setTimeout(showPopup, Math.floor(Math.random() * 20000) + 30000);
    };
    // Initial delay of 20 seconds
    timeoutId = setTimeout(showPopup, 20000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return <AnimatePresence data-id="element-156">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-brand-dark/95 backdrop-blur-md border border-brand-copper/30 shadow-[0_8px_30px_rgba(0,0,0,0.4)] rounded-xl p-4 flex items-start gap-4" data-id="element-157">
          <div className="bg-[#c4883a]/25 p-2.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-158">
            <CheckCircle2 className="w-5 h-5 text-[#c4883a]" data-id="element-159" />
          </div>
          <div data-id="element-160">
            <p className="text-[15px] font-semibold text-white" data-id="element-161">
              <span className="font-bold text-brand-copper" data-id="element-162">{currentName}</span>{' '}
              de {currentCity}
            </p>
            <p className="text-sm text-white/80 mt-1 font-medium" data-id="element-163">
              acaba de adquirir Sistema PRO
            </p>
            <p className="text-[11px] text-white/50 mt-2" data-id="element-164">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}